import React, { memo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { icons, buttons, layouts } from 'seal-ui-components';
import { useMenu } from '@Hooks/useMenu';
import HelpModal from '@Components/HelpModal/HelpModal';
import { HeaderMenuToggle } from '@Actions/navigationActions';
import TopNavListItem from '../TopNavListItem';
import { MenuListSideOverlay, MenuList } from './TopNavList.style';

const TopNavList = memo(() => {
    const dispatch = useDispatch();
    const { isHeaderMenuOpened } = useSelector(state => state.headerNavigation);
    const headerMenu = useMenu();

    const [isOpen, setIsOpen] = useState(false);
    const [pathName, setPathname] = useState(undefined);

    const toggleModal = pathname => {
        setIsOpen(!isOpen);
        setPathname(pathname);
    };

    return (
        <>
            {isOpen && <HelpModal onRequestClose={toggleModal} pathname={pathName} />}
            <MenuListSideOverlay openMenu={isHeaderMenuOpened}>
                <layouts.VerticalBox className="menuList-container">
                    <MenuList data-testid="top-nav-menu">
                        <buttons.InsetIconButton
                            size="large"
                            icon={<icons.CrossLargeIcon />}
                            onClick={() => dispatch(HeaderMenuToggle(!isHeaderMenuOpened))}
                            data-testid="toggle_cross_button"
                        />
                        {headerMenu.topMenu.map(
                            menuItem =>
                                menuItem.show && (
                                    <TopNavListItem
                                        key={`TopNavListItem_${menuItem.name}_link`}
                                        menuItem={menuItem}
                                        toggleModal={toggleModal}
                                    />
                                )
                        )}
                    </MenuList>
                    <layouts.BoxSpacer />
                    <layouts.VerticalBoxDivider />
                    <MenuList data-testid="footer-nav-menu">
                        {headerMenu.bottomMenu.map(
                            menuItem =>
                                menuItem.show && (
                                    <TopNavListItem
                                        key={`TopNavListItem_${menuItem.name}_link`}
                                        menuItem={menuItem}
                                    />
                                )
                        )}
                    </MenuList>
                </layouts.VerticalBox>
            </MenuListSideOverlay>
        </>
    );
});

export default TopNavList;
